module.exports = __webpack_public_path__ + "img/download-icon.3d39ae55.svg";